module.exports = __webpack_public_path__ + "img/stop-logo.7833fc60.png";